const CHAT_LIGHT_VARS = {
    '--chat-hue': '257',
    '--chat-l-accent': '0.58',
    '--chat-l-accent-bubble': '0.54',
    '--chat-c-accent': '0.2',
    '--chat-l-surface': '0.99',
    '--chat-l-surface-bubble': '1',
    '--chat-l-text': '0.23',
    '--chat-l-text-muted': '0.49',
    '--chat-l-text-subtle': '0.58',
    '--chat-l-text-faint': '0.66',
    '--chat-l-privileged-bubble-other': '0.96',
    '--chat-c-privileged-bubble-other': '0.03',
    '--chat-l-privileged-text-other': '0.37',
    '--chat-c-privileged-text-other': '0.1',
    '--chat-l-privileged-border-other': '0.79',
    '--chat-c-privileged-border-other': '0.07',
    '--chat-l-privileged-border-restricted': '0.58',
    '--chat-c-privileged-border-restricted': '0.13',
    '--chat-h-privileged-border-restricted': '30',
    '--chat-l-privileged-meta-visible': '0.45',
    '--chat-c-privileged-meta-visible': '0.08',
    '--chat-l-privileged-meta-restricted': '0.54',
    '--chat-c-privileged-meta-restricted': '0.09',
    '--chat-h-privileged-meta-restricted': '30',
};
export const getChatCSSVars = () => CHAT_LIGHT_VARS;
//# sourceMappingURL=theme.js.map